export const postcodeRe = /^\d{4}\s?[A-Za-z]{2}$/;
export const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const phoneRe = /^\+?[0-9][0-9\s\-]{6,16}$/;

export function validateContact(v, t) {
  const e = {};
  if (!v.name?.trim()) e.name = t.form.errors.required;
  if (!v.phone?.trim()) e.phone = t.form.errors.required;
  else if (!phoneRe.test(v.phone.trim())) e.phone = t.form.errors.phone;
  if (!v.email?.trim()) e.email = t.form.errors.required;
  else if (!emailRe.test(v.email.trim())) e.email = t.form.errors.email;
  if (!v.preferred_channel) e.preferred_channel = t.form.errors.required;
  if (!v.consent) e.consent = t.form.errors.consent;
  return e;
}

// Rough monthly minimums (€) per city to trigger a friendly budget warning.
const CITY_MIN = {
  Amsterdam: 1400, Utrecht: 1200, "Den Haag": 1100, Haarlem: 1200,
  Amstelveen: 1300, Rotterdam: 1000, Leiden: 1100, Delft: 1000,
};

export function budgetTooLow(cities = [], budgetMax) {
  if (!budgetMax) return false;
  return cities.some((c) => CITY_MIN[c] && budgetMax < CITY_MIN[c]);
}
